// Generic scroll-reveal for Living Water sections.
// A container marked [data-lw-reveal] gets .lw-reveal--init (hidden state) added by
// JS only, then .lw-reveal--in when it scrolls into view. Its direct children are
// staggered via CSS nth-child transition-delay. With JS off or reduced-motion on,
// nothing is ever hidden — and a timeout safety net guarantees content never stays
// hidden even if the observer never fires for an element.
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  var els = [].slice.call(document.querySelectorAll('[data-lw-reveal]'));
  if (!els.length) return;

  function reveal(el) {
    el.classList.add('lw-reveal--in');
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        io.unobserve(entry.target);
      });
    },
    { threshold: 0.15 }
  );

  els.forEach(function (el) {
    el.classList.add('lw-reveal--init');
    io.observe(el);
    // Safety net: never leave content hidden if the observer never fires.
    setTimeout(function () {
      if (!el.classList.contains('lw-reveal--in')) {
        reveal(el);
        io.unobserve(el);
      }
    }, 2500);
  });
})();
